/**
 * 国际化 中文
 * zh_CN
 */
module.exports = {
	home: {
		'title': 'mallPC',
	},
	header:{
		'new-add':'最新加入的商品',
	},
	footer: {
		'txt1': '',
		'txt2': '',
		'icp': '',
	},
	common: {
		'add-car':'添加购物车',
		'concat-admin':'联系客服',
		'go-car':'去购物车',
		'all-goods':'全部商品',
		'settle':'结算',
		'require-error':'请求错误',
		'tips':'提示',
		'sub': '提交',
		'cancle': '取消',
		'loading':'加载中',
		'loading2': '请稍候...',
		'register':'注册',
		'log':'登录',
		'confirm-msg':"确认退出？",
		'logout':'退出',
		'logout-msg':'已退出登录',
		'goods-name':'商品名称',
		'sms':'验证码',
		'edit':'编辑',
		'delete':'删除',
		'selectAll': '全选',
		'goBuy':'去购买',
		'no-goods':'暂无相关商品',
		'prev-text': '上一页',
		'next-text': '下一页',
		'msg1': '请先登录',

		// 页面标题/页面名称
		pageHead: {
			'index': '首页',
			'classify': '商品分类',
			'address': '收货地址',
			'collect':'我的收藏',
			'history': '浏览历史',
			'my': '个人中心',
			'login': '登录',
			'register': '注册',
			'productDetail': '商品详情',
			'order':'订单中心',
			'orderDetail': '订单详情',
		},
	},
	search: {
		'sort1': '综合',
		'sort2': '销量',
		'sort3': '价格升序',
		'sort4': '价格降序',
		'txt1': '全部结果',
	},
	address:{
		'title': '我的收货地址',
		'add-address':'新增收货地址',
		'edit-address':'编辑收货地址',
		'del-address':'确认删除该地址?',
		'is_default':'默认地址',

		'receive_name':'收货人',
		'phone':'手机号',
		'area':'省市区',
		'address_detail':'详细地址',
		'setDefault':'设为默认',
		'set':'操作',
		'tip1':'请输入收货人姓名',
		'tip2':'请输入收货人手机号',
		'tip3':'请选择省市区',
		'tip4':'请输入收货人详细地址',
		'tip5':'请粘贴您的收货人信息',
		'tip6':'请输入正确的手机号',
		'btn1': '加载更多地址',
		'intelli-recog':'智能识别',
		'clear':'清空',
		'recog':'识别',
		'warn1': '请输入需要识别的收货人信息',
	},
	classify: {
		'txt1': '没有更多商品',
		'txt2': '正在加载更多商品',
	},
	collect: {
		'checkAll':'全选',
		'cancle-collect':'取消收藏',
		'batch-set':'批量操作',
		'cancle-set':'取消操作',
		'tip1':'请选择收藏商品',
		'txt1':'没有更多收藏商品',
		'txt2':'正在加载更多收藏商品',
	},
	history: {
		'checkAll':'全选',
		'cancle-history':'删除历史',
		'batch-set':'批量操作',
		'cancle-set':'取消操作',
		'today': '今日',
		'yesterday': '昨日',
		'tip1':'请选择浏览历史',
		'txt1':'没有更多浏览历史',
		'txt2':'正在加载更多浏览历史',
	},
	comment: {
		'lb1': '商品预览图',
		'lb2': '商品名称',
		'lb3': '规格',
		'lb4': '相符描述：',
		'lb5': '评价：',
		'lb6': '评价图片：',
		'ph1': '说说哪里好,其他顾客想知道',
		'warn1': '您有商品还没有评星哦',
		'warn2': '每件商品最多上传5张评价图片',
		'warn3': '您有商品还没有填写评价内容呢',
	},
	'403': {
		'txt1': '啊哦~ 你没有权限访问该页面哦',
		'txt2': '返回首页',
		'txt3': '返回上一页',
	},
	'404': {
		'txt1': '啊哦~ 你所访问的页面不存在',
		'txt2': '返回登录页',
		'txt3': '返回上一页',
	},
	logistics: {
		'txt1':'物流公司：',
		'txt2':'物流编号：',
		'lb1':'日期',
		'lb2':'状态',

		// status
		'status-lb1':'日期',
		'status-lb2':'状态',
		'status-lb3':'信息',
	},
	order: {
		'ph1': '商品名称/订单号',
		'lb1': '全部',
		'lb2': '待付款',
		'lb3': '待发货',
		'lb4': '待收货',
		'lb5': '待评价',
		'lb6': '待退款',
		'lb7': '--6--',
		'lb8': '已关闭',
		'lb9': '--8--',
		'lb10': '订单号',
		'lb11': '商品',
		'lb12': '规格信息',
		'lb13': '订单金额',
		'lb14': '状态',
		'lb15': '创建时间',
		'lb16': '操作',
		'txt1': '搜索',
		'txt2': '待付款',
		'txt3': '待发货',
		'txt4': '待收货',
		'txt5': '退换中',
		'txt6': '已完成',
		'txt7': '退换成功',
		'txt8': '已关闭',
		'txt9': '去支付',
		'txt10': '取消订单',
		'txt11': '查看订单',
		'txt12': '退款',
		'txt13': '确认收货',
		'txt14': '退换货',
		'txt15': '取消退款',
		'txt16': '去评价',
		'txt17': '海关清关状态',
		'txt18': '查看物流',
		'dialog1': '海关清关状态',
		'dialog2': '物流信息',
		'dialog3': '申请退款',
		'dialog4': '退换货',
		'dialog5': '去评价',
		'msg1': '确认取消订单？',

		// orderDetail
		'dtl-txt1': '订单信息',
		'dtl-txt2': '订单编号：',
		'dtl-txt3': '订单状态：',
		'dtl-txt4': '收货人信息',
		'dtl-txt5': '收货人：',
		'dtl-txt6': '收货地址：',
		'dtl-txt7': '物流',
		'dtl-txt8': '物流：',
		'dtl-txt9': '商品信息',
		'dtl-txt10': '备注：',
		'dtl-txt11': '总重量：',
		'dtl-txt12': '运费：',
		'dtl-txt13': '实付款：',
		'dtl-lb1': '商品',
		'dtl-lb2': '规格',
		'dtl-lb3': '单价',
		'dtl-lb4': '数量',
		'dtl-lb5': '总价',
		'dtl-msg1': '该订单是否完成支付？',
		'dtl-msg2': '提示',
		'dtl-msg3': '已完成',

		// old
		'order-info':'订单信息',
		'order-no':'订单编号',
		'order-status':'订单状态',
		'reciver-info':'收货人信息',
		'pay-way':'支付方式',
		'now-pay':'立即支付',
		'reciver':'收货人',
		'reciver-address':'收货地址',
		'goods-info':'商品信息',
		'add-address':'新增收货地址',
		'more-address':'显示更多地址',
		'pick-address':'收起地址',
		'no-address':'您还没有添加收货地址',
		'aplipay':'支付宝支付',
		'wxpay':'微信支付',
		'goods':'商品',
		'spec':'规格',
		'price':'单价',
		'number':'数量',
		'total':'总价',
		'total-weight':'总重量',
		'discount':'使用优惠券',
		'actual-payment':'实付款',
		'sub-order':'提交订单',
		'pay-finish':'支付完成',
		'tip1':'该订单是否已支付完成？',
		'tap1':'全部',
		'tap2':'待付款',
		'tap3':'待发货',
		'tap4':'待收货',
		'tap5':'待评价',
		'tap6':'待退款',
		'tip7':'退换中',
		'tip8':'退换成功',
		'tip9':'已关闭',
		'tip10':'已完成',
		'order-total':'订单金额',
		'status':'状态',
		'create-time':'创建时间',
		'set':'操作',
		'go-pay':'去支付',
		'cancel-order':'取消订单',
		'confirm-order':'确认收货',
		'logistics':'查看物流',
		'look':'查看',
		'carriage':'运费',
		'include-carriage':'含运费'
	},
	pay: {
		// cancelRefundFn
		'crf-msg1': '确认取消退款？',

		// exchange
		'ex-lb1': '商品预览图',
		'ex-lb2': '商品名称',
		'ex-lb3': '规格',
		'ex-lb4': '价格 x 数量',
		'ex-lb5': '快递公司：',
		'ex-lb6': '快递单号：',
		'ex-ph1': '请选择快递公司',
		'ex-ph2': '请填写快递单号',
		'ex-txt1': '规格：',
		'ex-txt2': '订单金额：',
		'ex-txt3': '总重：',
		'ex-txt4': '运费：',
		'ex-txt5': '实付款：',
		'ex-txt6': '商品金额',
		'ex-msg1': '请选择快递公司',
		'ex-msg2': '请填写快递单号',

		// refund
		'rf-lb1': '申请说明：',
		'rf-lb2': '联系手机号：',
		'rf-ph1': '请您详细填写申请说明',
		'rf-ph2': '请填写联系手机号',
		'rf-msg1': '请填写联系手机号',
		'rf-msg2': '手机号格式错误',
		'rf-form1': '无',
	},
	car:{
		'del-goods':'删除选中的商品',
		'selected':'已选择',
		'p1':'件商品',
		'empty':'购物车空空如也~',
		'tb-lb1': '商品',
		'tb-lb2': '规格',
		'tb-lb3': '单价',
		'tb-lb4': '数量',
		'tb-lb5': '总价',
		'tb-lb6': '操作',
		'txt1-1': '已选择',
		'txt1-2': '件商品',
		'txt2': '总价：',
		'msg1': '您还没有选择商品哦!',
	},
	index: {
		// modular_one
		'1-txt1': '去购买',
		'1-txt2': '查看更多',

		// modular_three
		'3-txt1': '去购买',
		'3-txt2': '查看更多',
	},
	login: {
		'title': '登录',
		'ph1': '请输入手机号',
		'ph2': '请输入验证码',
		'txt1': '获取验证码',
		'txt2': '我同意',
		'txt3': '《汇奢享用户协议》',
		'txt4': '《隐私协议》',
		'txt5': '登录',
		'txt6': '与',
		'msg1': '请输入手机号',
		'msg2': '手机号格式错误',
		'msg3': '验证码发送成功',
		'msg4': '请输入验证码',
		'msg5': '请同意《汇奢享用户协议》与《隐私政策》',
		'reg-title1': '店铺入驻',
		'reg-title2': '注册',
		'reg-txt1': '注册并登录',
	},
	my: {
		'txt1': '我的上级:',
		'txt2': '余额',
		'txt3': '我的邀请码',
		'txt4': '我的收藏',
		'txt5': '浏览历史',
		'title1': '我的订单',
			'order1': '待付款',
			'order2': '待发货',
			'order3': '待收货',
			'order4': '待评价',
			'orderlist': '全部订单',
		'title2': '我的服务',
			'server1': '我的收货地址',
			'server2': '联系客服',
			'server3': '清关信息',
			'server4': '邀请码',
			'server5': '设置',
		'dialog1': '',
			'kefuTitle': '扫描二维码添加客服微信',
		'dialog2': '编辑清关信息',
			'bind-txt1': '应海关总署要求，请填写本账户信息',
			'bind-txt2': '同意汇奢享',
			'bind-txt3': '《隐私政策》',
			'bind-ph1': '请输入实际支付人姓名',
			'bind-ph2': '请输入实际支付人手机号',
			'bind-ph3': '请输入实际支付人身份证号',
			'bind-msg1': '请输入实际支付人姓名',
			'bind-msg2': '请输入实际支付人手机号',
			'bind-msg3': '手机号格式不正确',
			'bind-msg4': '请输入实际支付人身份证号',
			'bind-msg5': '身份证号格式不正确',
			'bind-msg6': '请同意汇奢享《隐私政策》',
			'bind-msg7': '实名信息修改成功',
			'bind-msg8': '实名信息录入成功',
		'dialog3': '邀请码',
			'invite-lb1': '邀请码：',
			'invite-ph1': '请输入邀请码',
		'dialog4': '设置',
			'setting-txt1': '隐私政策',
			'setting-txt2': '汇奢享用户协议',
			'setting-txt3': '注销账户',
			'setting-txt4': '退出登录',
	},
	productDetail: {
		'price':'价格',
		'introduce':'商品介绍',
		'evaluate':'商品评价',
		'shipment-info':'发货信息',
		'review':'浏览',
		'sold':'已售',
		'specs':'规格',
		'related-products':'相关商品',
		'shop':'店铺',
		'p1':'进口税',
		'p2':'包税',
		'p3':'商品已包税',
		'p4':'商品税费：该商品价格已包税；',
		'p5':'进口税计算：进口税=商品完税价格（包括运费）*税率（完税价格由海关最终认定）；',
		'p6':'根据国家政策规定，个人单笔交易限值金额5000元，个人年度交易限值总金额26000元，限值金额以内按跨境电商综合税征收。',
		'p7':'费用说明',
		'p8':'数量',
		'p9':'配送流程',
		'p10':'正品货源',
		'p11':'义乌保税区',
		'p12':'消费者',
		'p13':'立即购买',
		'p14':'收藏商品',
		'p15':'已收藏',
		'p16':'暂无评价',
		'p17':'库存：',
		'p18':'件',
		'msg1': '商品库存不足',
		'msg2': '购买数量超过库存',
		'msg3': '暂无评价',
		'msg4': '暂无评价',
		'msg5': '暂无评价',
		'msg6': '暂无评价',
	},
}



// WEBPACK FOOTER //
// ./src/assets/i18n/zh.js